var map = {
	"./wscn-icon-stack.vue": 1759,
	"./wscn-icon-svg.vue": 1760
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1988;


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon-svg nonrecursive \.vue$
// module id = 1988
// module chunks = 502